var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-outages-messages" },
    _vm._l(_vm.cmsContent.toastMessage, function (message) {
      return _c(
        "div",
        {
          staticClass: "c-outages-messages__message",
          class: { "c-outages-messages__message--show": _vm.active },
        },
        [
          _c("img", {
            staticClass: "c-outages-messages__message-icon",
            attrs: { src: message.MessageIcon, width: "45", height: "45" },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "c-outages-messages__message-text",
            domProps: { innerHTML: _vm._s(message.MessageText) },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "c-outages-messages__message-close",
            on: { click: _vm.hideMessage },
          }),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }